module.exports = __webpack_public_path__ + "static/media/choithramsOffersB.403d3490.png";